export default __webpack_public_path__ + "static/media/bg8.ac3c23fa.jpg";